import { FeatureAccessFeature } from 'constants/FeatureAccessFeature';
import {
  FEATURE_ACCESS__AVAILABILITIES,
  FEATURE_ACCESS__DATA_WIZARD,
  FEATURE_ACCESS__JOB_APPLICANTS,
  FEATURE_ACCESS__TIME_REGISTRATION,
} from 'translations/constants';

/** Column, panel and request order — the same order the API always returns. */
export const FEATURES: FeatureAccessFeature[] = [
  FeatureAccessFeature.TIME_REGISTRATION,
  FeatureAccessFeature.AVAILABILITIES,
  FeatureAccessFeature.DATA_WIZARD,
  FeatureAccessFeature.JOB_APPLICANTS,
];

export const FEATURE_LABEL_KEYS: Record<FeatureAccessFeature, string> = {
  [FeatureAccessFeature.TIME_REGISTRATION]: FEATURE_ACCESS__TIME_REGISTRATION,
  [FeatureAccessFeature.AVAILABILITIES]: FEATURE_ACCESS__AVAILABILITIES,
  [FeatureAccessFeature.DATA_WIZARD]: FEATURE_ACCESS__DATA_WIZARD,
  [FeatureAccessFeature.JOB_APPLICANTS]: FEATURE_ACCESS__JOB_APPLICANTS,
};

export const PAGE_SIZE_OPTIONS = [10, 50, 500];
export const INITIAL_PAGE_SIZE = 10;
export const TABLE_HEADER_HEIGHT_PX = 74;
export const TABLE_ROW_HEIGHT_PX = 78.5;
export const TABLE_ROW_SPACING_PX = 4;
